@if (
  (sharedService.logged_in_user?.role !== "No Role Found" &&
  sharedService.logged_in_user?.role) ||
  (sharedService.environment === "test" && !(sharedService.kiosk_mode$ | async))
  ) {
  <div [@fadeIn] style="height: 100vh" class="sidenav" [@divState]="state">
    <div style="text-align: left; font-size: 13px">
      <div
        class="row"
        style="color: white"
        [style.padding-top]="
          (networkSync.isOnline$ | async) === false ? '32px' : '0'
        "
        >
        @if (state === "collapse") {
          <i
            class="fas fa-angle-double-right"
            style="text-align: right; margin-right: 5px"
            (click)="expandSideNav()"
          ></i>
        }
        @if (state === "expand") {
          <i
            class="fas fa-angle-double-left"
            style="text-align: right; margin-right: 5px"
            (click)="collapseSideNav(); collapseAllMenus()"
          ></i>
        }
        @if (state === "expand" && sharedService.logged_in_user?.role) {
          <span style="text-align: center; font-size: 18px; font-weight: 500; color: ghostwhite">
            {{ (sharedService.company_info_retrieved$ | async)?.company_name }}
          </span>
        }
        @if (state === "expand") {
          <span style="text-align: center">
            <span [title]="'Role: ' + sharedService.logged_in_user?.role" placement="bottom">Logged In: {{ sharedService.logged_in_user?.name_first || "" }}</span>
            {{
            (sharedService.logged_in_user?.name_last || "")
            .charAt(0)
            .toUpperCase()
            }}.
            @if (unreadAlertsCount > 0) {
              <!-- Active Alerts Bell -->
              <span
                class="ms-2"
                (click)="onBellClicked()"
                style="cursor: pointer"
                >
                <i class="fas fa-bell text-warning"></i>
              </span>
            } @else {
              <!-- Empty Alerts Bell -->
              <span
                class="ms-2"
                (click)="onBellClicked()"
                style="cursor: pointer"
                >
                <i class="far fa-bell" style="color: white" [title]="'No Alerts'" placement="bottom"></i>
              </span>
            }

            <i
              class="fas fa-circle fa-sm"
              style="margin-left: 5px"
              [ngClass]="serverConnected ? 'text-success' : 'text-danger'"
              [title]="
                serverConnected ? 'Server Connected' : 'Server Disconnected'
              "
            ></i>
            <i
              class="fa-solid fa-arrow-right-arrow-left ms-2"
              [ngClass]="
                (networkSync.pendingItemsCount$ | async) === 0
                  ? 'text-success'
                  : 'text-danger'
              "
              [title]="
                (networkSync.pendingItemsCount$ | async) === 0
                  ? 'Data Synced'
                  : ((networkSync.pendingItemsCount$ | async) +
                    ' change(s) pending sync')
              "
              placement="bottom"
            ></i>
          </span>
        }
      </div>
    </div>
    <!-- GIF, App Name-->
    <div class="row" style="text-align: center">
      @if (state === "expand") {
        <img
          src="assets/images/logo/current_logo_transparent_white_letters.png"
          alt="FFL XCEL Logo"
          class="title"
          style="max-width: 90%; height: auto; margin: 0 auto"
          />
        }
      </div>

      <div
        #scrollContainer
        class="sideNavHeader"
        style="overflow-y: auto; overflow-x: hidden; height: calc(100vh - 180px)"
        (scroll)="boundbookSelect?.close()"
        >
        <button
          type="button"
          class="btn btn-secondary btn-sm"
          (click)="routeClicked('home')"
          placement="right" container="body" boundariesElement="window"
          aria-controls="collapseBasic"
          style="width: 100%; margin-bottom: 20px"
          >
          <i
            class="fa-solid fa-house"
          [ngClass]="{
            icon_expand: state === 'expand',
            icon_collapse: state === 'collapse',
          }"
            style="text-align: right; margin-right: 5px"
          ></i>
          @if (state === "expand") {
            <span>Home</span>
          }
        </button>

        <!-- Setup Checklist — visible until all tasks are done -->
        @if (
          sharedService.company_info_loaded &&
          (sharedService.setupTasksRemaining ?? 0) > 0
          ) {
          <button
            type="button"
            class="btn btn-warning btn-sm"
            (click)="routeClicked('setup-checklist')"
            placement="right" container="body" boundariesElement="window"
            [tooltip]="state === 'collapse' ? 'Setup Checklist' : null"
          style="
            width: 100%;
            margin-bottom: 20px;
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
          "
            >
            <i class="fas fa-clipboard-list"></i>
            @if (state === "expand") {
              <span>Setup Checklist</span>
              <span
                class="badge text-dark ms-1"
              style="
                background: rgba(0, 0, 0, 0.25);
                padding: 4px 7px;
                font-size: 0.78rem;
              "
                >{{ sharedService.setupTasksRemaining }}</span
                >
              }
            </button>
          }

          <!-- Admin -->
          <!-- *ngIf="startupService.is_admin" -->
          @if (getFeatureVisibility('admin', 'admin') && isAdmin()) {
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              (click)="toggleAdmin()"
              [attr.aria-expanded]="!admin_is_collapsed"
              aria-controls="collapseBasic"
              style="width: 100%"
              [tooltip]="state === 'collapse' ? 'Admin' : null"
              placement="right" container="body" boundariesElement="window"
              >
              <i
                class="fa-solid fa-user"
          [ngClass]="{
            icon_expand: state === 'expand',
            icon_collapse: state === 'collapse',
          }"
                style="text-align: right; margin-right: 5px"
              ></i>
              @if (state === "expand") {
                <span>Admin</span>
              }
            </button>
          }
          <!-- Admin Dropdown-->
          <div
            id="collapseBasic"
            [collapse]="admin_is_collapsed"
            [isAnimated]="true"
            >
            <div class="well well-lg card card-block card-header">
              @if (getFeatureVisibility('admin', 'account-dashboard') && (sharedService.setupTasksRemaining !== 0 || sharedService.recommendedTasksRemaining !== 0)) {
                <div
                  class="sideNavListItem"
                  >
                  <p (click)="routeClicked('setup-checklist')">
                    Setup Checklist
                    @if (sharedService.setupTasksRemaining > 0) {
                      <span
                        class="badge bg-warning text-dark ms-1"
                        style="font-size: 0.7rem"
                        >{{ sharedService.setupTasksRemaining }}</span
                        >
                      }
                      @if (sharedService.recommendedTasksRemaining > 0) {
                        <span
                          class="badge bg-info text-dark ms-1"
                          style="font-size: 0.7rem"
                          >{{ sharedService.recommendedTasksRemaining }}</span
                          >
                        }
                      </p>
                    </div>
                  }
                  @if (getFeatureVisibility('admin', 'account-dashboard')) {
                    <div
                      class="sideNavListItem"
                      >
                      <p (click)="routeClicked('account-dashboard')">Account Dashboard</p>
                    </div>
                  }
                  @if (getFeatureVisibility('admin', 'firearm-management')) {
                    <div
                      class="sideNavListItem"
                      >
                      <p (click)="routeClicked('firearm-management')">
                        Firearm Management
                      </p>
                    </div>
                  }
                  @if (getFeatureVisibility('admin', 'ffl-management')) {
                    <div
                      class="sideNavListItem"
                      >
                      <p (click)="routeClicked('ffl-management')">FFL Management</p>
                    </div>
                  }
                  <!-- Sub Button => Lists-->
                  @if (getFeatureVisibility('admin', 'reporting')) {
                    <div
                      class="well well-lg card card-block card-header"
                      >
                      <button
                        type="button"
                        class="btn btn-secondary btn-sm"
                        (click)="admin_reporting_collapsed = !admin_reporting_collapsed"
                        [attr.aria-expanded]="!admin_reporting_collapsed"
                        aria-controls="collapseBasic"
                        style="width: 100%"
                        >
                        Reporting
                      </button>
                      <div
                        id="collapseBasic"
                        [collapse]="admin_reporting_collapsed"
                        [isAnimated]="true"
                        >
                        <!-- Sales Table -->
                        @if (getFeatureVisibility('admin', 'transfer-reporting')) {
                          <div
                            class="sideNavListItem"
                            >
                            <p (click)="routeClicked('transfer-reporting')">
                              Transfer Reporting
                            </p>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>

              <!-- Non-Admin User Management -->
              @if (!isAdmin()) {
                <button
                  type="button"
                  class="btn btn-secondary btn-sm"
                  (click)="routeClicked('user-management')"
                  style="width: 100%;"
                  [tooltip]="state === 'collapse' ? 'My Profile' : null"
                  placement="right" container="body" boundariesElement="window"
                  >
                  <i
                    class="fa-solid fa-user-pen"
              [ngClass]="{
                icon_expand: state === 'expand',
                icon_collapse: state === 'collapse',
              }"
                    style="text-align: right; margin-right: 5px"
                  ></i>
                  @if (state === "expand") {
                    <span>User Management</span>
                  }
                </button>
              }

              <!-- Accounting -->
              <!-- *ngIf="startupService.is_admin" -->
              @if (getFeatureVisibility('accounting', 'accounting')) {
                <button
                  type="button"
                  class="btn btn-secondary btn-sm"
                  (click)="toggleAccounting()"
                  [attr.aria-expanded]="!accounting_is_collapsed"
                  aria-controls="collapseBasic"
                  style="width: 100%; margin-top: 20px"
                  [tooltip]="state === 'collapse' ? 'Accounting' : null"
                  placement="right" container="body" boundariesElement="window"
                  >
                  <i
                    class="fa-solid fa-dollar-sign"
          [ngClass]="{
            icon_expand: state === 'expand',
            icon_collapse: state === 'collapse',
          }"
                    style="text-align: right; margin-right: 5px"
                  ></i>
                  @if (state === "expand") {
                    <span>Accounting</span>
                  }
                </button>
              }
              <!-- Accounting Dropdown-->
              <div
                id="collapseBasic"
                [collapse]="accounting_is_collapsed"
                [isAnimated]="true"
                >
                <!-- Create Sales Receipt -->
                @if (getFeatureVisibility('accounting', 'create-sales-receipt')) {
                  <div
                    class="sideNavListItem"
                    >
                    <p
            (click)="
              sharedService.canUseFeature(
                'accounting',
                'create-sales-receipt'
              ) && routeClicked('accounting-sales-receipt')
            "
            [style.opacity]="
              !sharedService.canUseFeature('accounting', 'create-sales-receipt')
                ? '0.5'
                : '1'
            "
            [style.cursor]="
              !sharedService.canUseFeature('accounting', 'create-sales-receipt')
                ? 'not-allowed'
                : 'pointer'
            "
            [tooltip]="
              sharedService.getFeatureDisabledReason(
                'accounting',
                'create-sales-receipt'
              ) || ''
            "
                      [placement]="state === 'collapse' ? 'right' : 'bottom'"
                      [container]="'body'"
                      >
                      Create Sales Receipt
                      @if (
                        !sharedService.canUseFeature("accounting", "create-sales-receipt")
                        ) {
                        <i
                          class="fa-solid fa-triangle-exclamation ms-2 text-warning"
                          style="font-size: 12px"
                        ></i>
                      }
                    </p>
                  </div>
                }
                <!-- Create Expense -->
                @if (getFeatureVisibility('accounting', 'create-expense')) {
                  <div
                    class="sideNavListItem"
                    >
                    <p
            (click)="
              sharedService.canUseFeature('accounting', 'create-expense') &&
                routeClicked('accounting-expense')
            "
            [style.opacity]="
              !sharedService.canUseFeature('accounting', 'create-expense')
                ? '0.5'
                : '1'
            "
            [style.cursor]="
              !sharedService.canUseFeature('accounting', 'create-expense')
                ? 'not-allowed'
                : 'pointer'
            "
            [tooltip]="
              sharedService.getFeatureDisabledReason(
                'accounting',
                'create-expense'
              ) || ''
            "
                      [placement]="state === 'collapse' ? 'right' : 'bottom'"
                      [container]="'body'"
                      >
                      Create Expense
                      @if (!sharedService.canUseFeature("accounting", "create-expense")) {
                        <i
                          class="fa-solid fa-triangle-exclamation ms-2 text-warning"
                          style="font-size: 12px"
                        ></i>
                      }
                    </p>
                  </div>
                }
                <!-- Sub Button => Lists-->
                @if (getFeatureVisibility('accounting', 'lists')) {
                  <div
                    class="well well-lg card card-block card-header"
                    >
                    <button
                      type="button"
                      class="btn btn-secondary btn-sm"
                      (click)="accounting_lists_collapsed = !accounting_lists_collapsed"
                      [attr.aria-expanded]="!accounting_lists_collapsed"
                      aria-controls="collapseBasic"
                      style="width: 100%"
                      >
                      Lists
                    </button>
                    <div
                      id="collapseBasic"
                      [collapse]="accounting_lists_collapsed"
                      [isAnimated]="true"
                      >
                      <!-- Sales Table -->
                      @if (getFeatureVisibility('accounting', 'sales-table')) {
                        <div
                          class="sideNavListItem"
                          >
                          <p (click)="routeClicked('accounting-sales-table')">
                            Sales Table
                          </p>
                        </div>
                      }
                      <!-- Expense Table -->
                      @if (getFeatureVisibility('accounting', 'expense-table')) {
                        <div
                          class="sideNavListItem"
                          >
                          <p (click)="routeClicked('accounting-expense-table')">
                            Expense Table
                          </p>
                        </div>
                      }
                      <!-- Products & Services -->
                      @if (getFeatureVisibility('accounting', 'product-services')) {
                        <div
                          class="sideNavListItem"
                          >
                          <p (click)="routeClicked('accounting-products-services')">
                            Products & Services
                          </p>
                        </div>
                      }
                      <!-- Contacts -->
                      @if (getFeatureVisibility('accounting', 'contacts')) {
                        <div
                          class="sideNavListItem"
                          >
                          <p (click)="routeClicked('accounting-contacts-table')">
                            Contacts
                          </p>
                        </div>
                      }
                    </div>
                  </div>
                }
                <!-- Sub Button => Accounting Reports -->
                @if (getFeatureVisibility('accounting', 'reports')) {
                  <div
                    class="well well-lg card card-block card-header"
                    >
                    <button
                      type="button"
                      class="btn btn-secondary btn-sm"
            (click)="
              accounting_reports_collapsed = !accounting_reports_collapsed
            "
                      [attr.aria-expanded]="!accounting_reports_collapsed"
                      aria-controls="collapseBasic"
                      style="width: 100%"
                      >
                      Accounting Reports
                    </button>
                    <div
                      id="collapseBasic"
                      [collapse]="accounting_reports_collapsed"
                      [isAnimated]="true"
                      >
                      <!-- Profit & Loss -->
                      @if (
                        getFeatureVisibility('accounting-reporting', 'profit-loss')
                        ) {
                        <div
                          class="sideNavListItem"
                          >
                          <p (click)="routeClicked('profit-loss')">Profit & Loss</p>
                        </div>
                      }
                      <!-- Balance Sheet -->
                      @if (
                        getFeatureVisibility('accounting-reporting', 'balance-sheet')
                        ) {
                        <div
                          class="sideNavListItem"
                          >
                          <p (click)="routeClicked('balance-sheet')">Balance Sheet</p>
                        </div>
                      }
                      <!-- Cost of Goods Sold -->
                      @if (
                        getFeatureVisibility(
                        'accounting-reporting',
                        'cost-of-goods-sold'
                        )
                        ) {
                        <div
                          class="sideNavListItem"
                          >
                          <p (click)="routeClicked('cost-of-goods-sold')">
                            Cost of Goods Sold
                          </p>
                        </div>
                      }
                      <!-- Cash Flow Statement -->
                      @if (
                        getFeatureVisibility(
                        'accounting-reporting',
                        'cash-flow-statment'
                        )
                        ) {
                        <div
                          class="sideNavListItem"
                          >
                          <p (click)="routeClicked('cash-flow-statment')">
                            Cash Flow Statement
                          </p>
                        </div>
                      }
                      <!-- Sales Tax libility -->
                      @if (
                        getFeatureVisibility(
                        'accounting-reporting',
                        'sales-tax-libility'
                        )
                        ) {
                        <div
                          class="sideNavListItem"
                          >
                          <p (click)="routeClicked('sales-tax-libility')">
                            Sales Tax Libility
                          </p>
                        </div>
                      }
                    </div>
                  </div>
                }
                <!-- Single Items -->
              </div>
              <!-- Boundbook -->
              <div style="margin-top: 10px; text-align: center">
                @if (state === 'expand') {
                  <span style="color: white">Selected Boundbook</span>
                  <ng-select
                    #boundbookSelect
                    [items]="sharedService.available_boundbooks"
                    [multiple]="false"
                    [closeOnSelect]="true"
                    bindLabel="boundbook_name"
                    placeholder="Select Boundbook"
                    [(ngModel)]="sharedService.selected_boundbook"
                    (change)="boundbookChanged($event)"
                    (contextmenu)="$event.preventDefault()"
                    appendTo="body"
                    class="form-control text-uppercase input small"
                    id="boundbook"
                    >
                    <ng-template ng-footer-tmp>
                      <div class="d-flex justify-content-between">
                        <button
                          class="btn btn-sm btn-dark"
                          style="width: 100%"
                          (click)="sharedService.openNewBoundBookModal()"
                          >
                          New Boundbook
                        </button>
                      </div>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                      <div
                        style="width: 100%; height: 100%"
                        (contextmenu)="onBoundBookContextMenu($event, item)"
                        >
                        @if (item.default) {
                          <i
                            class="fa fa-star fa-2xs text-warning ms-1"
                            title="Default"
                          ></i>
                        }
                        {{ item.boundbook_name }}
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <div
                        style="width: 100%; height: 100%"
                        (contextmenu)="onBoundBookContextMenu($event, item)"
                        >
                        @if (item.default) {
                          <i
                            class="fa fa-star fa-2xs text-warning ms-1"
                            title="Default"
                          ></i>
                        }
                        {{ item.boundbook_name }}
                      </div>
                    </ng-template>
                  </ng-select>
                } @else {
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    (click)="expandSideNav()"
                    [tooltip]="'Selected Boundbook: ' + (sharedService.selected_boundbook?.boundbook_name || 'None')"
                    placement="right" container="body" boundariesElement="window"
                    style="width: 100%;"
                    >
                    <i class="fa-solid fa-book-bookmark icon_collapse" style="text-align: right; margin-right: 5px;"></i>
                  </button>
                }
              </div>
              <!-- Acquisitions -->
              @if (getFeatureVisibility('acquisitions', 'acquisitions')) {
                <button
                  type="button"
                  class="btn btn-secondary btn-sm"
                  (click)="toggleAcquisitions()"
                  [attr.aria-expanded]="!acquisitions_is_collapsed"
                  aria-controls="collapseBasic"
                  style="width: 100%; margin-top: 20px"
                  [tooltip]="state === 'collapse' ? 'Acquisitions' : null"
                  placement="right" container="body" boundariesElement="window"
                  [disabled]="!this.sharedService.selected_boundbook.boundbook_id"
                  >
                  <i
                    class="fa-solid fa-plus"
          [ngClass]="{
            icon_expand: state === 'expand',
            icon_collapse: state === 'collapse',
          }"
                    style="text-align: right; margin-right: 5px"
                  ></i>
                  @if (state === "expand") {
                    <span>Acquisitions</span>
                  }
                </button>
              }
              <div
                id="collapseBasic"
                [collapse]="acquisitions_is_collapsed"
                [isAnimated]="true"
                >
                <div class="well well-lg card card-block card-header">
                  @if (getFeatureVisibility('acquisitions', 'acquisition')) {
                    <div
                      class="sideNavListItem"
                      >
                      <p (click)="routeClicked('acquisition')">Acquisition</p>
                    </div>
                  }
                  @if (getFeatureVisibility('acquisitions', 'bulk-acquisitions')) {
                    <div
                      class="sideNavListItem"
                      >
                      <p (click)="routeClicked('acquisition-bulk')">Bulk Acquisitions</p>
                    </div>
                  }
                </div>
              </div>
              <!-- Dispositions -->
              @if (getFeatureVisibility('dispositions', 'dispositions')) {
                <button
                  type="button"
                  class="btn btn-secondary btn-sm"
                  (click)="toggleDispositions()"
                  [attr.aria-expanded]="!dispositions_is_collapsed"
                  aria-controls="collapseBasic"
                  style="width: 100%; margin-top: 20px"
                  [tooltip]="state === 'collapse' ? 'Dispositions' : null"
                  placement="right" container="body" boundariesElement="window"
                  [disabled]="!this.sharedService.selected_boundbook.boundbook_id"
                  >
                  <i
                    class="fa-solid fa-minus"
          [ngClass]="{
            icon_expand: state === 'expand',
            icon_collapse: state === 'collapse',
          }"
                    style="text-align: right; margin-right: 5px"
                  ></i>
                  @if (state === "expand") {
                    <span>Dispositions</span>
                  }
                </button>
              }
              <div
                id="collapseBasic"
                [collapse]="dispositions_is_collapsed"
                [isAnimated]="true"
                >
                <div class="well well-lg card card-block card-header">
                  @if (
                    getFeatureVisibility('dispositions', 'start-new-disposition')
                    ) {
                    <div
                      class="sideNavListItem"
                      >
                      <p (click)="routeClicked('disposition-selection')">
                        New Disposition
                      </p>
                    </div>
                  }
                  @if (getFeatureVisibility('dispositions', 'build-disposition')) {
                    <div
                      class="sideNavListItem"
                      >
                      <p (click)="routeClicked('disposition-build')">Disposition Build</p>
                    </div>
                  }
                  @if (getFeatureVisibility('dispositions', 'pending-dispositions')) {
                    <div
                      class="sideNavListItem"
                      >
                      <p (click)="routeClicked('pending-dispositions')">
                        Pending Dispositions
                      </p>
                    </div>
                  }
                  @if (getFeatureVisibility('dispositions', '4473')) {
                    <div
                      class="sideNavListItem"
                      >
                      <p (click)="routeClicked('buyer-form-4473')">4473</p>
                    </div>
                  }
                  @if (getFeatureVisibility('dispositions', 'reserved_firearms')) {
                    <div
                      class="sideNavListItem"
                      >
                      <p (click)="routeClicked('reserved-firearms')">Reserved Firearms</p>
                    </div>
                  }
                  @if (getFeatureVisibility('dispositions', 'reserved_4473')) {
                    <div
                      class="sideNavListItem"
                      >
                      <p (click)="routeClicked('reserved-4473')">Reserved 4473</p>
                    </div>
                  }
                </div>
              </div>
              <!-- Bound Book -->
              @if (getFeatureVisibility('boundbook', 'boundbook')) {
                <button
                  type="button"
                  class="btn btn-secondary btn-sm"
        [disabled]="
          sharedService.logged_in_user?.role !== 'Admin' &&
          sharedService.logged_in_user?.role !== 'Developer' &&
          sharedService.logged_in_user?.role !== 'Viewer' &&
          sharedService.logged_in_user?.role !== 'User' &&
          sharedService.environment !== 'test'
        "
                  style="width: 100%; margin-top: 20px"
                  (click)="routeClicked('bound-book')"
                  [tooltip]="state === 'collapse' ? 'Bound Book' : null"
                  placement="right" container="body" boundariesElement="window"
                  [disabled]="!this.sharedService.selected_boundbook.boundbook_id"
                  >
                  <i
                    class="fa-solid fa-book"
          [ngClass]="{
            icon_expand: state === 'expand',
            icon_collapse: state === 'collapse',
          }"
                    style="text-align: right; margin-right: 5px"
                  ></i>
                  @if (state === "expand") {
                    <span>Bound Book</span>
                  }
                </button>
              }
              <!-- Calendar -->
              @if (getFeatureVisibility('calendar', 'calendar')) {
                <button
                  type="button"
                  class="btn btn-secondary btn-sm"
                  (click)="routeClicked('calendar')"
                  [tooltip]="state === 'collapse' ? 'Calendar' : null"
                  placement="right" container="body" boundariesElement="window"
                  style="width: 100%; margin-top: 20px"
                  >
                  <i
                    class="fa-solid fa-calendar"
          [ngClass]="{
            icon_expand: state === 'expand',
            icon_collapse: state === 'collapse',
          }"
                    style="text-align: right; margin-right: 5px"
                  ></i>
                  @if (state === "expand") {
                    <span>Event Calendar</span>
                  }
                </button>
              }
              <!-- Vendors -->
              @if (getFeatureVisibility('vendor-inventory', 'vendor-inventory')) {
                <button
                  type="button"
                  class="btn btn-secondary btn-sm"
                  (click)="toggleVendor()"
                  [attr.aria-expanded]="!Vendor_is_collapsed"
                  aria-controls="collapseBasic"
                  style="width: 100%; margin-top: 20px"
                  [tooltip]="state === 'collapse' ? 'Vendor Inventory' : null"
                  placement="right" container="body" boundariesElement="window"
                  >
                  <i
                    class="fa-solid fa-warehouse"
          [ngClass]="{
            icon_expand: state === 'expand',
            icon_collapse: state === 'collapse',
          }"
                    style="text-align: right; margin-right: 5px"
                  ></i>
                  @if (state === "expand") {
                    <span>Vendor Inventory</span>
                  }
                </button>
              }
              <div
                id="collapseBasic"
                [collapse]="Vendor_is_collapsed"
                [isAnimated]="true"
                >
                <div class="well well-lg card card-block card-header">
                  @if (
                    getFeatureVisibility('vendor-inventory', 'live-vendor-inventory')
                    ) {
                    <div
                      class="sideNavListItem"
                      >
                      <p
              (click)="
                networkSync.isOnline &&
                  sharedService.canUseFeature(
                    'vendor-inventory',
                    'live-vendor-inventory'
                  ) &&
                  routeClicked('vendor-dashboard')
              "
              [style.opacity]="
                !networkSync.isOnline ||
                !sharedService.canUseFeature(
                  'vendor-inventory',
                  'live-vendor-inventory'
                )
                  ? '0.5'
                  : '1'
              "
              [style.cursor]="
                !networkSync.isOnline ||
                !sharedService.canUseFeature(
                  'vendor-inventory',
                  'live-vendor-inventory'
                )
                  ? 'not-allowed'
                  : 'pointer'
              "
              [tooltip]="
                !networkSync.isOnline
                  ? 'Feature unavailable while offline'
                  : sharedService.getFeatureDisabledReason(
                      'vendor-inventory',
                      'live-vendor-inventory'
                    ) || ''
              "
                        [placement]="state === 'collapse' ? 'right' : 'bottom'"
                        [container]="'body'"
                        >
                        Live Vendor Data
                        @if (
                          !networkSync.isOnline ||
                          !sharedService.canUseFeature(
                          "vendor-inventory",
                          "live-vendor-inventory"
                          )
                          ) {
                          <i
                            class="fa-solid fa-triangle-exclamation ms-2 text-warning"
                            style="font-size: 12px"
                          ></i>
                        }
                      </p>
                    </div>
                  }
                  @if (
                    getFeatureVisibility('vendor-inventory', 'inventory-reports')
                    ) {
                    <div
                      class="sideNavListItem"
                      >
                      <p
              (click)="
                networkSync.isOnline &&
                  sharedService.canUseFeature(
                    'vendor-inventory',
                    'inventory-reports'
                  ) &&
                  routeClicked('inventory-request-lists')
              "
              [style.opacity]="
                !networkSync.isOnline ||
                !sharedService.canUseFeature(
                  'vendor-inventory',
                  'inventory-reports'
                )
                  ? '0.5'
                  : '1'
              "
              [style.cursor]="
                !networkSync.isOnline ||
                !sharedService.canUseFeature(
                  'vendor-inventory',
                  'inventory-reports'
                )
                  ? 'not-allowed'
                  : 'pointer'
              "
              [tooltip]="
                !networkSync.isOnline
                  ? 'Feature unavailable while offline'
                  : sharedService.getFeatureDisabledReason(
                      'vendor-inventory',
                      'inventory-reports'
                    ) || ''
              "
                        [placement]="state === 'collapse' ? 'right' : 'bottom'"
                        [container]="'body'"
                        >
                        Inventory Alerts
                        @if (
                          !networkSync.isOnline ||
                          !sharedService.canUseFeature(
                          "vendor-inventory",
                          "inventory-reports"
                          )
                          ) {
                          <i
                            class="fa-solid fa-triangle-exclamation ms-2 text-warning"
                            style="font-size: 12px"
                          ></i>
                        }
                      </p>
                    </div>
                  }
                  @if (
                    getFeatureVisibility('vendor-inventory', 'inventory-reports')
                    ) {
                    <div
                      class="sideNavListItem"
                      >
                      <p
              (click)="
                networkSync.isOnline &&
                  sharedService.canUseFeature(
                    'vendor-inventory',
                    'inventory-reports'
                  ) &&
                  routeClicked('purchase-optimizer')
              "
              [style.opacity]="
                !networkSync.isOnline ||
                !sharedService.canUseFeature(
                  'vendor-inventory',
                  'inventory-reports'
                )
                  ? '0.5'
                  : '1'
              "
              [style.cursor]="
                !networkSync.isOnline ||
                !sharedService.canUseFeature(
                  'vendor-inventory',
                  'inventory-reports'
                )
                  ? 'not-allowed'
                  : 'pointer'
              "
              [tooltip]="
                !networkSync.isOnline
                  ? 'Feature unavailable while offline'
                  : sharedService.getFeatureDisabledReason(
                      'vendor-inventory',
                      'inventory-reports'
                    ) || ''
              "
                        [placement]="state === 'collapse' ? 'right' : 'bottom'"
                        [container]="'body'"
                        >
                        Purchase Optimizer
                        @if (
                          !networkSync.isOnline ||
                          !sharedService.canUseFeature(
                          "vendor-inventory",
                          "inventory-reports"
                          )
                          ) {
                          <i
                            class="fa-solid fa-triangle-exclamation ms-2 text-warning"
                            style="font-size: 12px"
                          ></i>
                        }
                      </p>
                    </div>
                  }
                </div>
              </div>

              <!-- FFL Look-Up -->
              <button
                type="button"
                class="btn btn-secondary btn-sm"
                (click)="routeClicked('ffl-lookup')"
                [tooltip]="state === 'collapse' ? 'FFL Look-Up' : null"
                placement="right" container="body" boundariesElement="window"
                style="width: 100%; margin-top: 20px"
                >
                <i
                  class="fa-solid fa-magnifying-glass"
          [ngClass]="{
            icon_expand: state === 'expand',
            icon_collapse: state === 'collapse',
          }"
                  style="text-align: right; margin-right: 5px"
                ></i>
                @if (state === "expand") {
                  <span>FFL Look-Up</span>
                }
              </button>
              <!-- kiosk mode -->
              <span
        [tooltip]="
          !networkSync.isOnline
            ? 'Kiosk mode is unavailable while offline'
            : state === 'collapse'
              ? 'Kiosk Mode'
              : null
        "
                [placement]="state === 'collapse' ? 'right' : 'bottom'"
                [container]="'body'"
                style="display: block; width: 100%"
                >
                @if (getFeatureVisibility('kiosk-mode', 'kiosk-mode')) {
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    (click)="enterKioskMode()"
                    [disabled]="!networkSync.isOnline"
                    aria-controls="collapseBasic"
                    style="width: 100%; margin-top: 20px"
                    >
                    <i
                      class="fa-solid fa-tv"
            [ngClass]="{
              icon_expand: state === 'expand',
              icon_collapse: state === 'collapse',
            }"
                      style="text-align: right; margin-right: 5px"
                    ></i>
                    @if (state === "expand") {
                      <span>Kiosk Mode</span>
                      @if (!networkSync.isOnline) {
                        <i
                          class="fa-solid fa-triangle-exclamation ms-2 text-warning"
                          style="font-size: 12px"
                        ></i>
                      }
                    }
                  </button>
                }
              </span>
              <!-- Help -->
              @if (getFeatureVisibility('help', 'help')) {
                <button
                  type="button"
                  class="btn btn-secondary btn-sm"
                  (click)="toggleHelp()"
                  [attr.aria-expanded]="!help_is_collapsed"
                  aria-controls="collapseBasic"
                  style="width: 100%; margin-top: 20px"
                  [tooltip]="state === 'collapse' ? 'Help' : null"
                  placement="right" container="body" boundariesElement="window"
                  >
                  <i
                    class="fa-solid fa-circle-info"
          [ngClass]="{
            icon_expand: state === 'expand',
            icon_collapse: state === 'collapse',
          }"
                    style="text-align: right; margin-right: 5px"
                  ></i>
                  @if (state === "expand") {
                    <span>Help</span>
                  }
                </button>
              }
              <div
                id="collapseBasic"
                [collapse]="help_is_collapsed"
                [isAnimated]="true"
                >
                <div class="well well-lg card card-block card-header">
                  @if (getFeatureVisibility('help', 'help-doc')) {
                    <div
                      class="sideNavListItem"
                      >
                      <p (click)="routeClicked('help-doc')">Help Doc</p>
                    </div>
                  }
                  @if (getFeatureVisibility('help', 'tutorial')) {
                    <div
                      class="sideNavListItem"
                      >
                      <!-- <p (click)="routeClicked('tutorial')">Tutorial</p> -->
                      <p (click)="openPdf()">Tutorial</p>
                    </div>
                  }
                  @if (getFeatureVisibility('help', 'faqs')) {
                    <div
                      class="sideNavListItem"
                      >
                      <p (click)="routeClicked('faq')">FAQ's</p>
                    </div>
                  }
                </div>
              </div>
              <!-- Developer -->
              @if (isDeveloper()) {
                <button
                  type="button"
                  class="btn btn-secondary btn-sm"
                  (click)="openDeveloperControlsModal()"
                  [tooltip]="state === 'collapse' ? 'Developer' : null"
                  placement="right" container="body" boundariesElement="window"
                  style="width: 100%; margin-top: 20px"
                  >
                  <i
                    class="fa-solid fa-code"
          [ngClass]="{
            icon_expand: state === 'expand',
            icon_collapse: state === 'collapse',
          }"
                    style="text-align: right; margin-right: 5px"
                  ></i>
                  @if (state === "expand") {
                    <span>Developer</span>
                  }
                </button>
              }
              <!-- Settings -->
                      <button
                        type="button"
                        class="btn btn-secondary btn-sm"
                        (click)="openSettingsModal()"
                        placement="right" container="body" boundariesElement="window"
                        style="width: 100%; margin-top: 20px"
                        [tooltip]="state === 'collapse' ? 'Settings' : null"
                        >
                        <i
                          class="fa-solid fa-gear"
          [ngClass]="{
            icon_expand: state === 'expand',
            icon_collapse: state === 'collapse',
          }"
                          style="text-align: right; margin-right: 5px"
                        ></i>
                        @if (state === "expand") {
                          <span>Settings</span>
                        }
                      </button>
                      <!-- Log Out -->
                      <button
                        type="button"
                        class="btn btn-secondary btn-sm"
                        (click)="logout()"
                        placement="right" container="body" boundariesElement="window"
                        style="width: 100%; margin-top: 20px"
                        [tooltip]="state === 'collapse' ? 'Log Out' : null"
                        >
                        <i
                          class="fa-solid fa-sign-out-alt"
          [ngClass]="{
            icon_expand: state === 'expand',
            icon_collapse: state === 'collapse',
          }"
                          style="text-align: right; margin-right: 5px"
                        ></i>
                        @if (state === "expand") {
                          <span>Log Out</span>
                        }
                      </button>
                      <!-- Test-->
                      <!-- <button
                      *ngIf="getFeatureVisibility('test', 'test')"
                      type="button"
                      class="btn btn-secondary btn-sm"
                      (click)="test()"
                      placement="right" container="body" boundariesElement="window"
                      aria-controls="collapseBasic"
                      style="width: 100%; margin-top: 20px"
                      >
                      <i class="far fa-bookmark"></i>
                      @if (state === "expand") {
                        TEST
                      }
                    </button> -->

                  </div>

                  <!-- Version Badge -->
                  @if (state === "expand") {
                    <div class="version-badge">
                      <i class="fa-solid fa-code-branch me-1"></i>v{{ appVersion }}
                    </div>
                  }
                </div>
              }

              <!-- Bound Book Context Menu -->
              @if (showBoundBookMenu) {
                <div
                  class="custom-context-menu"
                  [style.top.px]="menuTop"
                  [style.left.px]="menuLeft"
                  >
                  <div class="menu-item" (click)="setDefault(contextMenuBook)">
                    <i class="fa fa-star me-2" style="color: gold"></i> Set as Default
                  </div>
                  <div class="menu-item" (click)="editName(contextMenuBook)">
                    <i class="fa fa-pencil me-2"></i> Edit Name
                  </div>
                </div>
              }
